export default __webpack_public_path__ + "static/media/google-books.f4b524ef.png";